import * as props from '../prop-names';
import { formatEvent, getAbsoluteUrlFromLocation } from '../helpers';

// One-time code login. Only the page URL and a failure reason are sent:
// never the email, the code or the token from the action payload.

export const getOtpFailureReason = error => {
  if (!error) return 'unknown';
  const status = error.status || error.statusCode;
  const text = `${error.error || ''} ${error.message || ''}`.toLowerCase();
  if (status === 429 || text.includes('too many') || text.includes('please wait')) {
    return 'rate_limited';
  }
  if (status) return `http_${status}`;
  return 'error';
};

const pageUrl = state => getAbsoluteUrlFromLocation(state?.Routing?.currentLocation);

export const trackOtpEvent = (type, payload, state) => {
  const event = formatEvent(type, payload);
  event.mp_properties = { [props.PAGE_URL]: pageUrl(state) };
  return event;
};

export const trackOtpFailedEvent = (type, payload, state) => {
  const event = formatEvent(type, payload);
  event.mp_properties = {
    [props.PAGE_URL]: pageUrl(state),
    [props.OTP_FAILURE_REASON]: getOtpFailureReason(payload),
  };
  return event;
};
